import styled, { css } from 'styled-components';
import { prop } from 'ramda';

import { Color, Layer } from '../../../../theme';
import { styleWhenTrue, hexToRgba } from '../../../../utils';

import { LanguagesListData } from './languageSwitch.types';

export const Container = styled.div`
  position: relative;
`;

export const FlagIcon = styled.img`
  margin-right: 10px;
  width: 18px;
  flex-shrink: 0;
`;

export const LanguageButton = styled.button`
  height: 54px;
  width: 54px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${Color.veryLightGrey};
  cursor: pointer;
  ${FlagIcon} {
    margin: 0;
  }
`;

export const LanguagesList = styled.div<LanguagesListData>`
  background-color: ${Color.darkGrey};
  box-shadow: 0 -1px 10px 0 ${hexToRgba(Color.black, 0.14)};
  padding: 27px 50px 27px 22px;
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  z-index: ${Layer.LanguageSwitch};
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s;
  ${styleWhenTrue(prop('isVisible'), css`
    opacity: 1;
    pointer-events: initial;
  `)}
`;

export const LanguageLabel = styled.div`
  color: ${Color.silver};
  font-size: 13px;
  letter-spacing: 0;
  line-height: 15px;
  transition: color 0.2s;
`;

export const LanguagePosition = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  & + & {
    margin-top: 19px;
  }
  &:hover {
    ${LanguageLabel} {
      color: ${Color.white};
    }
  }
`;
